import React, { useState } from 'react'
import { CommonAddress } from '@/components/common'
import {
  SubSection,
  StyledDemoGrid,
  DemoComponent,
  StyledSizeLabel,
} from '../styled.jsx'

export const AddressSection = () => {
  const [addressValue, setAddressValue] = useState({})
  const [selectedAddress, setSelectedAddress] = useState(null)
  const demoApiKey =
    process.env.REACT_APP_GOOGLE_MAP_API_KEY ||
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY

  return (
    <>
      <SubSection
        title='Address Autocomplete'
        description='Google Places-powered common address input'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Basic
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Standard'
            component={
              <CommonAddress
                id='demo-address'
                label='Address'
                value={addressValue}
                onChange={setAddressValue}
                onPlaceChange={setSelectedAddress}
                googleApiKey={demoApiKey}
                width='540px'
                fullWidth={false}
                placeholder='Start typing an address...'
              />
            }
            value={selectedAddress?.formatted_address}
          />
        </StyledDemoGrid>
      </SubSection>

      <SubSection title='Layout' description='Width and fullWidth variations'>
        <StyledSizeLabel variant='h6' gutterBottom>
          Sizes
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Fixed width'
            component={
              <CommonAddress
                id='demo-address-fixed'
                label='Address'
                value={addressValue}
                onChange={setAddressValue}
                googleApiKey={demoApiKey}
                width='340px'
                fullWidth={false}
              />
            }
          />
          <DemoComponent
            label='Full width'
            component={
              <CommonAddress
                id='demo-address-full'
                label='Address'
                value={addressValue}
                onChange={setAddressValue}
                googleApiKey={demoApiKey}
              />
            }
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
